export interface IContactForm {
  leadType: string
  leadSource: string
  title: string
  givenName: string
  fullName: string
  surname: string
  email: string
  phone: string
  state: string
  company: string
  zip: string
  contactMethod: string
  adviserInfo: string
  serviceType: string
  enquiryType: string
  message: string
  retUrl: string
  existingClient?: string
  industry?: string
  captcha_settings: any
  'g-recaptcha-response': string
  Web_Form_Campaign_Id_c: string
  utm_source?: string
  utm_medium?: string
  utm_content?: string
  utm_term?: string
  utm_name?: string
  whereHeard?: string
  otherCustomField?: any
  country?: string
  source?: string
  customField1Question?: string
  customField1?: string
  customField2Question?: string
  customField2?: string
  customField3Question?: string
  customField3?: string
  customField4Question?: string
  customField4?: string
  customField5Question?: string
  customField5?: string
  '00N8t000000PQkk'?: string
  [key: string]: any // Add index signature
  Adviser_info_web__c?: string
  Website_Callback_for__c?: string
}

/**
 * salesforceConfig - this is just a collection of key/value where the value is the id of the
 * form input element (NOT the input value)
 *
 * !!!IMPORTANT - the salesforceConfig keys must match the Contact.vue form element ids
 */
const salesforceConfig: { [key: string]: string | undefined } = {
  retUrl: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_RETURL,
  givenName: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_GIVENNAME,
  fullName: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_FULLNAME,
  surname: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_SURNAME,
  email: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_EMAIL,
  title: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_TITLE,
  phone: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_PHONE,
  zip: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_ZIP,
  leadSource: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_LEAD_SOURCE,
  state: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_STATE,
  source: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_SOURCE,
  company: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_COMPANY,
  contactMethod: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_PREFERRED_CONTACT,
  serviceType: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_SERVICE_TYPE,
  adviserInfo: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_ADVISER_INFO,
  message: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_MESSAGE,
  industry: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_INDUSTRY,
  existingClient: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_EXISTING_CLIENT,
  leadType: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_LEAD_TYPE,
  enquiryType: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_ENQUIRY,
  Web_Form_Campaign_Id_c: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_WEB_FORM_CAMPAIGN_ID_C,
  Source__c: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_SOURCE,
  utm_source: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_UTM_SOURCE,
  utm_medium: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_UTM_MEDIUM,
  utm_content: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_UTM_CONTENT,
  utm_term: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_UTM_TERM,
  utm_name: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_UTM_NAME,
  whereHeard: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_WHERE_HEARD,
  captcha_settings: 'captcha_settings',
  'g-recaptcha-response': 'g-recaptcha-response',
  country: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_COUNTRY,
  otherCustomField: '',
  customField1Question: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_CUSTOM_FIELD_1_QUESTION,
  customField1: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_CUSTOM_FIELD_1,
  customField2Question: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_CUSTOM_FIELD_2_QUESTION,
  customField2: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_CUSTOM_FIELD_2,
  customField3Question: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_CUSTOM_FIELD_3_QUESTION,
  customField3: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_CUSTOM_FIELD_3,
  customField4Question: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_CUSTOM_FIELD_4_QUESTION,
  customField4: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_CUSTOM_FIELD_4,
  customField5Question: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_CUSTOM_FIELD_5_QUESTION,
  customField5: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_CUSTOM_FIELD_5,
  '00N8t000000PQkk': process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_WHERE_HEARD,
  '0058t000000JuYqAAK': '0058t000000JuYqAAK',
  Adviser_info_web__c: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_ADVISER_C,
  Website_Callback_for__c: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_WEB_C,
}

export class ContactService {
  private endpoint = ''

  constructor(endpoint?: string) {
    if (!endpoint) {
      throw new Error('Config error, contact endpoint not configured')
    }
    this.endpoint = endpoint
  }

  /**
   * mapFormToSalesforce - this function iterates over the salesforceConfig key/values
   * It creates an object of salesforceConfig keys: Contact.Vue values which will be used
   * as the form payload in submitForm below
   *
   * i.e. for utm_source input field it will have corresponding value 00N8t000000PAQE
   * utm_source: 00N8t000000PAQE
   * becomes
   * 00N8t000000PAQE: 'the utm source taken from the url query params'
   * in the returned salesforceForm object
   * !!!IMPORTANT - the salesforceConfig keys must match the Contact.vue form element ids
   */
  mapFormToSalesforce(form: IContactForm): any {
    const salesforceForm: any = {}
    type ObjectKey = keyof typeof form

    const sourceOfForm = window.location.href

    for (const key of Object.keys(salesforceConfig)) {
      const sfKey = salesforceConfig[key]
      const formKey = key as ObjectKey

      if (!sfKey) {
        continue
      }

      if (
        formKey === 'utm_medium' ||
        formKey === 'utm_source' ||
        formKey === 'utm_content' ||
        formKey === 'utm_term' ||
        formKey === 'utm_name'
      ) {
        // check if form[formKey] is empty, if it is, set it to form[sfKey]
        if (form[formKey] === '') {
          salesforceForm[sfKey] = form[sfKey]
          salesforceForm[formKey] = form[sfKey]
          continue
        }
        salesforceForm[formKey] = form[formKey]
      }

      if (key.includes('customField')) {
        salesforceForm[sfKey] = form[sfKey] || ''
        continue
      }

      if (key.includes('Adviser_info_web__c')) {
        salesforceForm[sfKey] = form['Adviser_info_web__c'] || ''
        continue
      }

      if (key.includes('Website_Callback_for__c')) {
        salesforceForm[sfKey] = form['Website_Callback_for__c'] || ''
        continue
      }

      if (key === 'source' || key === 'Source__c' || key === '00N2e000000OyqC') {
        salesforceForm[sfKey] = sourceOfForm
        continue
      }

      // Special handling for the "whereHeard" field
      if (key === '00N8t000000PQkk') {
        salesforceForm[sfKey] = form.whereHeard || form['00N8t000000PQkk'] || ''
        continue
      }

      salesforceForm[sfKey] = form[formKey] || ''

      if (sfKey === 'Web_Form_Campaign_Id_c' && salesforceForm[sfKey] === '') {
        salesforceForm[sfKey] = process.env['CRM_FORM_FIELD_VALUE_WEB_FORM_CAMPAIGN_ID_C']
      }

      if (key === 'enquiryType' || key === '00N2e000000OfRZ') {
        if (salesforceForm[sfKey]) {
          continue
        }
        salesforceForm[sfKey] = form.enquiryType || form['00N2e000000OfRZ'] || ''
        salesforceForm['00N2e000000OfRZ'] = form.enquiryType || form['00N2e000000OfRZ'] || ''
        continue
      }

      if (key === 'serviceType' || key === '00N0I00000Jxzgg') {
        if (salesforceForm[sfKey]) {
          continue
        }
        salesforceForm[sfKey] = form.serviceType || form['00N0I00000Jxzgg'] || ''
        salesforceForm['00N0I00000Jxzgg'] = form.serviceType || form['00N0I00000Jxzgg'] || ''
        continue
      }
    }

    // if form.message set to salesforceForm.message
    salesforceForm.message = form.message

    // add NEXT_PUBLIC_CRM_FORM_FIELD_ID_LEAD_TYPE to salesforceForm
    let leadType = process.env.NEXT_PUBLIC_CRM_FORM_FIELD_ID_LEAD_TYPE as string
    salesforceForm[leadType] = form.leadType
    const finalForm = {
      ...salesforceForm,

      country:
        process.env.NEXT_PUBLIC_NEXT_LOCATION === 'au'
          ? 'Australia'
          : process.env.NEXT_PUBLIC_NEXT_LOCATION === 'en-nz'
            ? 'New Zealand'
            : 'Australia',
      Source__c: sourceOfForm,
      oid: process.env.NEXT_PUBLIC_CRM_FORM_FIELD_VALUE_OID,
      utm_source: salesforceForm.utm_source || '',
      utm_medium: salesforceForm.utm_medium || '',
      utm_content: salesforceForm.utm_content || '',
      utm_term: salesforceForm.utm_term || '',
      captcha_settings: {
        keyname: 'Google_Recaptcha',
        fallback: 'true',
      },
    }
    return finalForm
  }

  async submitForm(form: any, endpoint: any) {
    const postData = JSON.stringify(form)
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: postData,
      })

      if (response.status >= 400) {
        throw new Error('Bad response from server')
      }
      const responseData = await response.json()

      return responseData
    } catch (error) {
      console.error('Error Submitting Form:', error)
      throw error
    }
  }
}
